import { supabase } from '@/lib/supabaseClient';

/**
 * Пожелание «какую коллекцию добавить».
 *
 * Пишет только функция submit_collection_wish: таблица закрыта от клиента
 * политикой, лимиты (на человека и на весь сервис) считает база. Текст
 * никогда не попадает в prompt — он для владельца продукта.
 */
export type CollectionWishStatus = 'ok' | 'invalid' | 'limit';

export const COLLECTION_WISH_MIN = 3;
export const COLLECTION_WISH_MAX = 500;

export async function submitCollectionWish(body: string): Promise<CollectionWishStatus> {
  if (!supabase) {
    throw new Error('Сервис недоступен. Попробуйте позже.');
  }

  const { data, error } = await supabase.rpc('submit_collection_wish', { p_body: body });

  if (error) {
    throw new Error('Не удалось отправить пожелание. Проверьте интернет и попробуйте ещё раз.');
  }

  return data === 'ok' || data === 'limit' ? data : 'invalid';
}
